const $progressBar = $('.page-loading .progress-bar');
let $header;
let $headerNav;
let mobileGa;
let isFirstTime = true;
let sectionPos;
let sectionPage;
let footerPos;
const $doc = $(document);
const $win = $(window);
const $body = (window.opera) ? (document.compatMode == "CSS1Compat" ? $('html') : $('body')) : $('html,body');
let winW, winH;
let nowPos;

/*==================================================*\
        Main Function
\*==================================================*/
const { createApp, ref, nextTick } = Vue;

createApp({
  setup() {
    const sections = ref([]);

    fetch('js/data.json')
      .then(res => res.json())
      .then(data => {
        sections.value = data.sections;
        nextTick(() => {
          const $progressBar = $('.progress-bar');
          listenImagesLoading(
            $('#app img'), // 可依實際區塊調整
            mainFunc,
            function(per, instance) {
              $progressBar.css({ width: per + '%' });
            }
          );
        });
      });

    return {
      sections
    };
  }
}).mount('#app');



function mainFunc() {
  $header = $('.page-header');
  $headerNav = $('.header-nav ul');

  windowEvents();

  $('.slickVideo').slick();

  $('._lb').each(function (i, v) {
    $(v).lightbox({
      filesDefaultExtension: '.' + ($(v).data('lbext') || 'html'),
      callback: function () {
        if (typeof lbOnload !== 'undefined') lbOnload();
      }
    });
  });

  $('._scrollto').on('click', function () {
    const target = $(this).data("scrollto");
    scrollto(target);
  });

  $('.header-gotop').on('click', function () {
    $('html, body').stop().animate({
      scrollTop: $('.kv').offset().top
    }, 500);
  });

  transitionThenRemove({
    dom: $(".page-loading"),
    duration: 300,
    callback: () => {
      console.log("%cBuild Completed!", 'color: green');
      // indexAni.play(); // 可視需要啟用
    }
  });

  
}

function windowEvents() {
  $win.on("resize", _resize).resize();
  $win.on("scroll", _scroll).scroll();
}

function _resize() {
  getSize();
  getSectionPos();
  footerPos = $('footer').offset().top;
}

function getSize() {
  winW = $win.width();
  winH = $win.height();
}

function getSectionPos() {
  sectionPos = [];
  sectionPage = [];

  $('.anchor').each((idx, el) => {
    sectionPos.push(Math.floor($(el).offset().top));
    sectionPage.push($(el).attr('data-page'));

  });
}

function _scroll() {
  getPos();
  setNavigationHint();

  const winTop = $win.scrollTop();
  if (winTop === 0) {
    gtag('event', 'pageName', { event_label: 'index' });
  }

  $header.css('opacity', winTop >= 250 ? '1' : '0');
}

function getPos() {
  nowPos = {
    x: $doc.scrollLeft(),
    y: $doc.scrollTop(),
    top: $doc.scrollTop() + 1
  };
}

function setNavigationHint() {
  const $navLi = $('.header-nav li');
  const NAV_HINT_CLASS = 'active';

  sectionPos.forEach((val, idx) => {
    if ((idx === 0 && nowPos.top < sectionPos[0]) || nowPos.top >= footerPos) {
      $navLi.removeClass(NAV_HINT_CLASS);
      return;
    }

    if (nowPos.top >= sectionPos[idx] && nowPos.top <= sectionPos[idx] + 25) {
      const label = winW > 768 ? sectionPage[idx] : 'm_' + sectionPage[idx];
      gtag('event', 'pageName', { event_label: label });
    }

    if (nowPos.top >= val) {
      $navLi.removeClass(NAV_HINT_CLASS);
      $navLi.eq(idx).addClass(NAV_HINT_CLASS);

      if (idx === 10) {
        // 活動二時不會保持活動辦法選單active
        $navLi.removeClass(NAV_HINT_CLASS);
        $navLi.eq(9).addClass(NAV_HINT_CLASS);
        return;
      }
      
      if (winW <= 768) {
        const posNav = $navLi.eq(idx).offset().left - $('.header-nav').offset().left + $('.header-nav').scrollLeft() - $navLi.eq(idx).width();
        $('.header-nav').scrollLeft(posNav);
      }
    }

    
  });
}

function scrollto(anchor) {
  $body.stop().animate({
    scrollTop: $('#' + anchor).offset().top
  }, 500);
}

function navScrollLeft() {
  const posNav = $('.header-nav .active').offset().left - ($(window).width() * 0.15);
  $('.header-nav').scrollLeft(posNav);
}


/* Reels */
var slideWrapper = $(".slickReels"),
    lazyImages = slideWrapper.find('.slide-image'),
    lazyCounter = 0;

const video = document.querySelector('video');
const videos = document.querySelectorAll('video');
const muteBtn = document.getElementById('muteBtn');

// When the slide is changing
function playPauseVideo(slick, control){
  var currentSlide, slideType, startTime, player, video;

  currentSlide = slick.find(".slick-current");
  video = currentSlide.children("video").get(0);
  slideType = currentSlide.attr("class").split(" ")[1];

  if (slideType === "video") {
    if (video != null) {
      if (control === "play"){
        video.play();
      } else {
        video.pause();
      }
    }
  }

  muteBtn.addEventListener('click', function() {
    if (currentSlide.hasClass('slick-active')) {
      if (video.paused) {
          video.play();
          $('.reelsVoice').removeClass('muted');
      } else {
          video.pause();
          $('.reelsVoice').addClass('muted');
      }
    }
  });
}

// DOM Ready
$(function() {

  /* Initialize */
  slideWrapper.on("init", function(slick){
    slick = $(slick.currentTarget);
    playPauseVideo(slick,"play");
    $('.reelsVoice').removeClass('muted');
    // setTimeout(function(){
    //   playPauseVideo(slick,"play");
    // }, 1000);
  });
  slideWrapper.on("beforeChange", function(event, slick) {
    slick = $(slick.$slider);
    playPauseVideo(slick,"pause");
    $('.reelsVoice').removeClass('muted');


  });
  slideWrapper.on("afterChange", function(event, slick) {
    slick = $(slick.$slider);
    playPauseVideo(slick,"play");
    $('.reelsVoice').removeClass('muted');
  });
  slideWrapper.on("lazyLoaded", function(event, slick, image, imageSource) {
    lazyCounter++;
    if (lazyCounter === lazyImages.length){
      lazyImages.addClass('show');
    }
  });

  slideWrapper.slick({
    slidesToShow: 3,
    infinite:true,
    lazyLoad:"progressive",
    cssEase:"cubic-bezier(0.87, 0.03, 0.41, 0.9)",
    arrows:true,
    responsive: [{
        breakpoint: 1235,
        settings: {
          slidesToShow: 3,
        }
      },{
        breakpoint: 1023,
        settings: {
          slidesToShow: 3,
        }
      },{
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          centerMode: true,
        }
      },{
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerMode: true,
        }
      }
    ]
  });

});